'use client'

import { zodResolver } from '@hookform/resolvers/zod'
import { useMutation } from '@tanstack/react-query'
import _ from 'lodash'
import { redirect } from 'next/navigation'
import { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { z } from 'zod'
import { authApi } from '@/api'
import { Alert, Button, Input, Password, PasswordPolicy } from '@/components'
import { useGlobalStore } from '@/store/provider'
import type { Auth } from '@/types'

const schema = z.object({
  code: z.string().min(1, 'Code is required'),
  password: z.string().min(8, 'Password must be at least 8 characters'),
})

export default function ConfirmPassword({ email, sendConfirmBack }: { email: string; sendConfirmBack: (confirmed: boolean) => void }) {
  const { user } = useGlobalStore((state) => state)
  useEffect(() => {
    if (!_.isEmpty(user)) {
      redirect('/')
    }
  }, [user])

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(schema),
  })

  const submit = async (data: Auth.ConfirmForgotPasswordRequest) => {
    try {
      await authApi.confirmForgotPassword(data)
      sendConfirmBack(true)
      return Promise.resolve()
    } catch (err) {
      return Promise.reject(err)
    }
  }

  const { mutate, error, isPending } = useMutation({ mutationFn: submit })
  const onSubmit = (data: any) => {
    mutate({ ...data, email })
  }
  return (
    <form noValidate autoComplete='off' className='space-y-3' onSubmit={handleSubmit(onSubmit)}>
      <div className='mb-4'>
        <span className='text-2xl font-bold'>2</span>. Enter the code and new password
      </div>
      <Input
        type='text'
        className='text-base py-2'
        label='Code'
        placeholder='code'
        {...register('code')}
        data-error={_.get(errors, 'code.message')}
      />
      <Password label='New Password' placeholder='new password' {...register('password')} data-error={_.get(errors, 'password.message')} />
      {error && <Alert variant='error' message={error.message} />}
      <div className='pt-2'>
        <PasswordPolicy />
      </div>
      <div className='pt-3'>
        <Button type='submit' className='w-full' working={isPending}>
          Reset Password
        </Button>
      </div>
    </form>
  )
}
